import React from "react";
import { get } from "lodash";
import { Button } from '@mui/material';

const ConfirmationMessage = ({
  handleUpdateOpenPopUp,
  currentUser,
  handleGenerateSenentceStarter,
  createFormData,
}) => {
  const isCanvasUser = !!get(currentUser, "canvas_id");

  return (
    <div style={{ zIndex: 13 }} className="allCreateLession">
      <div style={{ zIndex: 123 }}
        className={
          isCanvasUser ? "canvasuperLessionModalSec " : "creatLessionSection"
        }
      >
        <p>By creating a new lesson, your saved lesson will be replaced</p>
        <div className="createBtnSection">
          <Button
            onClick={() => {
              handleGenerateSenentceStarter(createFormData);
              handleUpdateOpenPopUp({ confirmationDialog: false, createFormData: undefined });
            }}
          >
            I agree
          </Button>
          <Button
            onClick={() => handleUpdateOpenPopUp({ confirmationDialog: false })}
          >
            Cancel
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationMessage;
